import React, { useEffect, useState } from 'react'
import Frame1 from './ingressinho_frames/frame_01.svg'
import Frame2 from './ingressinho_frames/frame_02.svg'
import Frame3 from './ingressinho_frames/frame_03.svg'
import Frame4 from './ingressinho_frames/frame_04.svg'
import Frame5 from './ingressinho_frames/frame_05.svg'
import Frame6 from './ingressinho_frames/frame_06.svg'
import Frame7 from './ingressinho_frames/frame_07.svg'
import Frame8 from './ingressinho_frames/frame_08.svg'
import Frame9 from './ingressinho_frames/frame_09.svg'
import Frame10 from './ingressinho_frames/frame_10.svg'
import Frame11 from './ingressinho_frames/frame_11.svg'
import Frame12 from './ingressinho_frames/frame_12.svg'
import Frame13 from './ingressinho_frames/frame_13.svg'
import Frame14 from './ingressinho_frames/frame_14.svg'
import Frame15 from './ingressinho_frames/frame_15.svg'
import Frame16 from './ingressinho_frames/frame_16.svg'
import Frame17 from './ingressinho_frames/frame_17.svg'
import Frame18 from './ingressinho_frames/frame_18.svg'
import Frame19 from './ingressinho_frames/frame_19.svg'
import Frame20 from './ingressinho_frames/frame_20.svg'
import Frame21 from './ingressinho_frames/frame_21.svg'
import Frame22 from './ingressinho_frames/frame_22.svg'
import Frame23 from './ingressinho_frames/frame_23.svg'
import Frame24 from './ingressinho_frames/frame_24.svg'

const frames = [
  Frame1,
  Frame2,
  Frame3,
  Frame4,
  Frame5,
  Frame6,
  Frame7,
  Frame8,
  Frame9,
  Frame10,
  Frame11,
  Frame12,
  Frame13,
  Frame14,
  Frame15,
  Frame16,
  Frame17,
  Frame18,
  Frame19,
  Frame20,
  Frame21,
  Frame22,
  Frame23,
  Frame24,
]

export type AnimatedIngressinhoProps = {
  speed?: number
}

const AnimatedIngressinho = ({ speed = 100 }: AnimatedIngressinhoProps) => {
  const [currentFrame, setCurrentFrame] = useState(0)

  useEffect(() => {
    let timeout: NodeJS.Timeout
    const nextFrame = () => {
      setCurrentFrame((prevFrame) => (prevFrame + 1) % frames.length)
      timeout = setTimeout(nextFrame, speed)
    }
    timeout = setTimeout(nextFrame, speed)

    return () => clearTimeout(timeout)
  }, [speed])

  const CurrentFrameComponent = frames[currentFrame]

  return (
    <div>
      <CurrentFrameComponent style={{ width: '100%', height: '100%' }} />
    </div>
  )
}

export default AnimatedIngressinho
